import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Bound } from "lib/@components/binding/Bound"
import { IconButton, Stack, TableCell, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { range } from "lib/range"
import { WeekPlanEntry } from "routes/plan/week-plan-entry"
import { PlannerItems } from "routes/plan/plugins/weekly-planner/plugins/planner-skills-schedule/planner-items"
import { ScheduleCode } from "routes/regime/schedule-code"
import { usePreviewSchedule } from "routes/schedule/preview-schedule"
import Iconify from "minimals-template/components/Iconify"
import { useDialog } from "lib/@hooks/useDialog"
import { WeekPlannerMoveDialog } from "routes/plan/plugins/weekly-planner/plugins/planner-schedule-list/week-planner-move-dialog"
import { isInPublishedRegime } from "routes/facilities/lib/when-parent-item"
import { If } from "lib/@components/switch"

const MAX_LENGTH = 60

export function ScheduleWeeks({ item, previous }) {
    const {
        stickyColumns,
        treeId,
        plan,
        allScheduleIndex,
        showHeader = (a, b) => a?.where !== b?.where,
        header = (scheduleItem) =>
            scheduleItem.where.includes("›") ? scheduleItem.where.split("›").slice(1).join("›") : scheduleItem.where,
        parentItem,
        isRegimeDraftLocked,
    } = useBoundContext()
    const scheduleItem = allScheduleIndex[item]
    const previousItem = allScheduleIndex[previous]
    const [folder, id] = item.split("!")
    const scheduleId = `${folder}~${treeId}!${id}`
    const preview = usePreviewSchedule(scheduleId, { fullScreen: false })

    const move = useDialog(<WeekPlannerMoveDialog plan={plan} scheduleItem={scheduleItem} scheduleId={scheduleId} />, {
        maxWidth: "md",
    })

    const allowChange = isInPublishedRegime(parentItem) || !isRegimeDraftLocked

    return (
        <Bound scheduleItem={scheduleItem} schedule={item}>
            {showHeader(previousItem, scheduleItem) ? (
                <PlannerItems.Item>
                    <TableRow>
                        <TableCell sx={{ position: "sticky", left: 0, zIndex: 7, bgcolor: "background.paper" }}>
                            <Typography
                                variant={scheduleItem.where.includes("›") ? "caption" : "body1"}
                                sx={{ fontWeight: "bold" }}
                            >
                                {header(scheduleItem, previousItem)}
                            </Typography>
                        </TableCell>
                        <TableCell
                            colSpan={52}
                            sx={{ bgcolor: (theme) => theme.palette.background.paper, backdropFilter: "blur(4px)" }}
                        />
                    </TableRow>
                </PlannerItems.Item>
            ) : null}
            <PlannerItems.Item>
                <TableRow>
                    <TableCell
                        sx={{
                            whiteSpace: "nowrap",
                            position: stickyColumns ? "sticky" : "",
                            left: 0,
                            bgcolor: "background.paper",
                            zIndex: 6,
                        }}
                    >
                        <Stack direction="row" spacing={1}>
                            <Typography variant="body2" sx={{ width: 510 }}>
                                {scheduleItem.schedule.title.slice(0, MAX_LENGTH)}
                                {scheduleItem.schedule.title.length >= MAX_LENGTH ? "..." : ""}
                                <IconButton
                                    aria-label="Preview schedule"
                                    color="primary"
                                    size="small"
                                    onClick={preview}
                                >
                                    <Iconify icon="mdi:eye" />
                                </IconButton>
                                <Bound schedule={{ id: scheduleId }}>
                                    <ScheduleCode sx={{ ml: 0, display: "inline-block" }} />
                                </Bound>
                            </Typography>
                            <If truthy={allowChange}>
                                <IconButton aria-label="Move planned date" size="small" color="primary" onClick={move}>
                                    <Iconify icon="mdi:gear" />
                                </IconButton>
                            </If>
                        </Stack>
                    </TableCell>
                    <Repeat list={range(0, 51)} item={<WeekPlanEntry />} />
                </TableRow>
            </PlannerItems.Item>
        </Bound>
    )
}
